export default {
  methods: {
    getPopulatedErrors (e) {
      const errors = this.$ota.general.getRESTV2CustomErrorMessages(e)

      if (errors) {
        return Object.values(errors).reduce((acc, error) => ({
          ...acc,
          [error.propertyPath]: {
            ...errors[error.propertyPath],
            populatedError: this.$t(error.locizeKey, {
              message: error.message
            })
          }
        }), {})
      }

      return null
    },
    formatErrors (errors) {
      return Object.values(errors).reduce((acc, error) => ({
        ...acc,
        [error.propertyPath]: error.populatedError
      }), {})
    }
  }
}
